"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyCustomReportResponseBodySchema = exports.AppleProxyCustomReportListResponseBodySchema = exports.CustomReportResponseSchema = exports.AppleProxyAdsReportResponseBodySchema = exports.AdsReportResponseSchema = exports.AdsReportSchema = exports.AdsReportRowSchema = exports.AdsReportMetadataSchema = exports.AppleProxySearchTermReportResponseBodySchema = exports.SearchTermReportSchema = exports.SearchTermReportRowSchema = exports.SearchTermReportMetadataSchema = exports.AppleProxyKeywordReportResponseBodySchema = exports.KeywordReportSchema = exports.KeywordReportRowSchema = exports.KeywordReportMetadataSchema = exports.AppleProxyAdGroupReportResponseBodySchema = exports.AdGroupReportSchema = exports.AdGroupReportRowSchema = exports.AdGroupReportMetadataSchema = exports.AppleProxyCampaignReportingResponseBodySchema = exports.CampaignReportSchema = exports.CampaignReportRowSchema = exports.CampaignReportMetadataSchema = exports.AppleProxyGrandTotalsRowSchema = exports.AppleProxyOtherSchema = exports.AppleProxyReportSpendRowSchema = exports.AppleProxyGranularitySchema = exports.AppleProxyExtendedSpendRowListSchema = exports.AppleProxyExtendedSpendRowSchema = exports.AppleProxySpendRowSchema = exports.AppleProxyReportingRequestSchema = exports.AppleProxyCustomReportRequestSchema = exports.AppleProxyTimeZoneSchema = exports.AppleProxyCustomReportStateSchema = exports.AppleProxyDateRangeSchema = exports.AppleProxyGranularityKeySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const utils_1 = require("../../../utils");
const campaigns_1 = require("./campaigns");
const core_2 = require("./core");
const AppleProxyReportingDateSchema = typebox_1.Type.String();
exports.AppleProxyGranularityKeySchema = (0, core_1.StringUnion)([
    "HOURLY",
    "DAILY",
    "WEEKLY",
    "MONTHLY",
]);
exports.AppleProxyDateRangeSchema = (0, core_1.StringUnion)([
    "LAST_WEEK",
    "LAST_2_WEEKS",
    "LAST_4_WEEKS",
]);
exports.AppleProxyCustomReportStateSchema = (0, core_1.StringUnion)([
    "QUEUED",
    "PENDING",
    "COMPLETED",
    "FAILED",
]);
const AppleProxyGroupBySchema = (0, core_1.StringUnion)([
    "deviceClass",
    "ageRange",
    "gender",
    "countryCode",
    "adminArea",
    "locality",
    "countryOrRegion",
]);
exports.AppleProxyTimeZoneSchema = (0, core_1.StringUnion)(["UTC", "ORTZ"]);
exports.AppleProxyCustomReportRequestSchema = (0, core_1.StrictObject)({
    dateRange: typebox_1.Type.Optional(exports.AppleProxyDateRangeSchema),
    endTime: typebox_1.Type.Optional(AppleProxyReportingDateSchema),
    granularity: typebox_1.Type.Optional(exports.AppleProxyGranularityKeySchema),
    name: typebox_1.Type.String({ maxLength: 50 }),
    selector: typebox_1.Type.Optional(core_2.AppleProxySelectorSchema),
    startTime: typebox_1.Type.Optional(AppleProxyReportingDateSchema),
});
exports.AppleProxyReportingRequestSchema = (0, core_1.StrictObject)({
    endTime: AppleProxyReportingDateSchema,
    granularity: typebox_1.Type.Optional(exports.AppleProxyGranularityKeySchema),
    groupBy: typebox_1.Type.Optional(typebox_1.Type.Array(AppleProxyGroupBySchema)),
    returnGrandTotals: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    returnRecordsWithNoMetrics: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    returnRowTotals: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    selector: core_2.AppleProxySelectorSchema,
    startTime: AppleProxyReportingDateSchema,
    timeZone: exports.AppleProxyTimeZoneSchema,
});
const AppleProxySpendRowFields = {
    tapInstallCPI: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    avgCPM: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    avgCPT: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    tapInstallRate: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    impressions: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    tapInstalls: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    localSpend: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    tapNewDownloads: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    tapRedownloads: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    taps: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    ttr: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    totalAvgCPI: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    totalInstallRate: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    totalInstalls: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    totalNewDownloads: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    totalRedownloads: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    viewInstalls: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    viewNewDownloads: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    viewRedownloads: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
};
exports.AppleProxySpendRowSchema = (0, core_1.StrictObject)(AppleProxySpendRowFields);
exports.AppleProxyExtendedSpendRowSchema = (0, core_1.StrictObject)({
    ...AppleProxySpendRowFields,
    date: (0, core_1.OptionalNullable)(AppleProxyReportingDateSchema),
});
exports.AppleProxyExtendedSpendRowListSchema = typebox_1.Type.Array(exports.AppleProxyExtendedSpendRowSchema);
exports.AppleProxyGranularitySchema = typebox_1.Type.Array(exports.AppleProxyExtendedSpendRowSchema, {
    title: "Granularity",
    description: "The report data organized by hour, day, week, and month.",
});
exports.AppleProxyReportSpendRowSchema = (0, utils_1.extendObject)(exports.AppleProxyExtendedSpendRowSchema, {
    title: "Total",
    description: "The tap, conversion, and monetary totals (SpendRow) in the response. This is the same as ExtendedSpendRow except it doesn't include the date attribute.",
});
exports.AppleProxyOtherSchema = typebox_1.Type.Boolean({
    title: "Other",
    description: "The impressions that return in reports when there are fewer than 100 demographic dimensions, and fewer than 10 search terms. If other is true, the corresponding dimensions are null.",
});
exports.AppleProxyGrandTotalsRowSchema = (0, core_1.StrictObject)({
    other: (0, core_1.OptionalNullable)(exports.AppleProxyOtherSchema),
    total: (0, core_1.OptionalNullable)(exports.AppleProxyReportSpendRowSchema),
}, {
    title: "Grand Totals",
    description: "A summary of cumulative report metrics.",
});
const AppleProxyKeywordBidRecommendationSchema = (0, core_1.StrictObject)({
    suggestedBidAmount: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
});
const AppleProxyKeywordInsightsSchema = (0, core_1.StrictObject)({
    bidRecommendation: (0, core_1.OptionalNullable)(AppleProxyKeywordBidRecommendationSchema),
}, {
    title: "Insights",
    description: "The bid recommendations according to currency Schema, including range and amount.",
});
const BaseReportRowProperties = {
    insights: (0, core_1.OptionalNullable)(AppleProxyKeywordInsightsSchema),
    granularity: (0, core_1.OptionalNullable)(exports.AppleProxyGranularitySchema),
    other: (0, core_1.OptionalNullable)(exports.AppleProxyOtherSchema),
    total: (0, core_1.OptionalNullable)(exports.AppleProxyReportSpendRowSchema),
};
const BaseReportRowSchema = typebox_1.Type.Object(BaseReportRowProperties);
/**
 * Reporting response types for campaign level reports
 */
exports.CampaignReportMetadataSchema = typebox_1.Type.Object({
    adChannelType: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    billingEvent: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    supplySources: (0, core_1.OptionalNullable)(campaigns_1.AppleProxySupplySourcesSchema),
    campaignId: core_1.IdSchema,
    campaignName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    campaignStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    app: (0, core_1.OptionalNullable)(typebox_1.Type.Object({
        appName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
        adamId: (0, core_1.OptionalNullable)(core_1.IdSchema),
    })),
    servingStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    servingStateReasons: campaigns_1.AppleProxyCampaignServingStateReasonsListSchema,
    countriesOrRegions: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
    modificationTime: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    totalBudget: (0, core_1.OptionalNullable)(typebox_1.Type.Object({
        amount: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
        currency: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    })),
    dailyBudget: (0, core_1.OptionalNullable)(typebox_1.Type.Object({
        amount: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
        currency: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    })),
    displayStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    orgId: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    countryOrRegionServingStateReasons: (0, core_1.OptionalNullable)(campaigns_1.AppleProxyCountryOrRegionServingStateReasonSchema),
    countryOrRegion: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    deviceClass: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
exports.CampaignReportRowSchema = typebox_1.Type.Object({
    ...BaseReportRowProperties,
    metadata: exports.CampaignReportMetadataSchema,
});
exports.CampaignReportSchema = typebox_1.Type.Object({
    grandTotals: (0, core_1.OptionalNullable)(exports.AppleProxyGrandTotalsRowSchema),
    row: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.CampaignReportRowSchema)),
});
const CampaignReportResponseSchema = typebox_1.Type.Object({
    reportingDataResponse: exports.CampaignReportSchema,
});
exports.AppleProxyCampaignReportingResponseBodySchema = (0, core_1.StrictObject)({
    data: (0, core_1.OptionalNullable)(CampaignReportResponseSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
/**
 * Reporting response types for ad group level reports
 */
exports.AdGroupReportMetadataSchema = typebox_1.Type.Object({
    adGroupId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    adGroupName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    startTime: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    endTime: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    cpaGoal: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    pricingModel: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    defaultBidAmount: (0, core_1.OptionalNullable)(typebox_1.Type.Object({
        amount: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
        currency: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    })),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    adGroupStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adGroupServingStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adGroupServingStateReasons: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
    modificationTime: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    automatedKeywordsOptIn: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    adGroupDisplayStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    campaignId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    orgId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    countryOrRegion: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    deviceClass: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
exports.AdGroupReportRowSchema = typebox_1.Type.Object({
    ...BaseReportRowProperties,
    metadata: exports.AdGroupReportMetadataSchema,
});
exports.AdGroupReportSchema = typebox_1.Type.Object({
    grandTotals: (0, core_1.OptionalNullable)(exports.AppleProxyGrandTotalsRowSchema),
    row: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AdGroupReportRowSchema)),
});
const AdGroupReportResponseSchema = typebox_1.Type.Object({
    reportingDataResponse: exports.AdGroupReportSchema,
});
exports.AppleProxyAdGroupReportResponseBodySchema = (0, core_1.StrictObject)({
    data: (0, core_1.OptionalNullable)(AdGroupReportResponseSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
/**
 * Reporting response types for keyword level reports
 */
exports.KeywordReportMetadataSchema = typebox_1.Type.Object({
    keywordId: (0, core_1.OptionalNullable)(core_1.IdSchema),
    keyword: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    keywordStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    matchType: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    bidAmount: (0, core_1.OptionalNullable)(typebox_1.Type.Object({
        amount: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
        currency: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    })),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    keywordDisplayStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adGroupId: (0, core_1.OptionalNullable)(core_1.IdSchema),
    adGroupName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adGroupDeleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    modificationTime: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
exports.KeywordReportRowSchema = typebox_1.Type.Object({
    ...BaseReportRowProperties,
    metadata: exports.KeywordReportMetadataSchema,
});
exports.KeywordReportSchema = typebox_1.Type.Object({
    grandTotals: (0, core_1.OptionalNullable)(exports.AppleProxyGrandTotalsRowSchema),
    row: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.KeywordReportRowSchema)),
});
const KeywordReportResponseSchema = typebox_1.Type.Object({
    reportingDataResponse: exports.KeywordReportSchema,
});
exports.AppleProxyKeywordReportResponseBodySchema = (0, core_1.StrictObject)({
    data: (0, core_1.OptionalNullable)(KeywordReportResponseSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
/**
 * Reporting search term types for keyword level reports
 */
exports.SearchTermReportMetadataSchema = typebox_1.Type.Object({
    keywordId: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    keyword: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    matchType: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    bidAmount: (0, core_1.OptionalNullable)(typebox_1.Type.Object({
        amount: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
        currency: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    })),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    keywordDisplayStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adGroupId: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    adGroupName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adGroupDeleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    searchTermText: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    countryOrRegion: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    searchTermSource: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
exports.SearchTermReportRowSchema = typebox_1.Type.Object({
    ...BaseReportRowProperties,
    metadata: exports.SearchTermReportMetadataSchema,
});
exports.SearchTermReportSchema = typebox_1.Type.Object({
    grandTotals: (0, core_1.OptionalNullable)(exports.AppleProxyGrandTotalsRowSchema),
    row: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.SearchTermReportRowSchema)),
});
const SearchTermReportResponseSchema = typebox_1.Type.Object({
    reportingDataResponse: exports.SearchTermReportSchema,
});
exports.AppleProxySearchTermReportResponseBodySchema = (0, core_1.StrictObject)({
    data: (0, core_1.OptionalNullable)(SearchTermReportResponseSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
/**
 * Reporting ads types for keyword level reports
 */
exports.AdsReportMetadataSchema = typebox_1.Type.Object({
    orgId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    campaignId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    adGroupId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    adId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    language: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    creativeId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    adName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    creativeType: typebox_1.Type.String(),
    status: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    displayStatus: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adServingStateReasons: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    creationTime: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    modificationTime: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
exports.AdsReportRowSchema = typebox_1.Type.Object({
    ...BaseReportRowProperties,
    metadata: exports.AdsReportMetadataSchema,
});
exports.AdsReportSchema = typebox_1.Type.Object({
    grandTotals: (0, core_1.OptionalNullable)(exports.AppleProxyGrandTotalsRowSchema),
    row: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AdsReportRowSchema)),
});
exports.AdsReportResponseSchema = typebox_1.Type.Object({
    reportingDataResponse: exports.AdsReportSchema,
});
exports.AppleProxyAdsReportResponseBodySchema = (0, core_1.StrictObject)({
    data: (0, core_1.OptionalNullable)(exports.AdsReportResponseSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.CustomReportResponseSchema = typebox_1.Type.Object({
    id: typebox_1.Type.Integer(),
    name: typebox_1.Type.String(),
    startTime: AppleProxyReportingDateSchema,
    endTime: AppleProxyReportingDateSchema,
    granularity: typebox_1.Type.Optional(exports.AppleProxyGranularityKeySchema),
    downloadUri: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    dimensions: typebox_1.Type.Array(typebox_1.Type.String()),
    metrics: typebox_1.Type.Array(typebox_1.Type.String()),
    selector: core_2.AppleProxySelectorSchema,
    state: exports.AppleProxyCustomReportStateSchema,
    creationTime: core_2.AppleProxyDateTimeSchema,
    modificationTime: core_2.AppleProxyDateTimeSchema,
});
exports.AppleProxyCustomReportListResponseBodySchema = (0, core_1.StrictObject)({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.CustomReportResponseSchema)),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyCustomReportResponseBodySchema = (0, core_1.StrictObject)({
    data: (0, core_1.OptionalNullable)(exports.CustomReportResponseSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
